import React from 'react';
import { StyledCarousel } from './Carousel.styled';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader

const Carousel = ({
    autoPlay = false,
    interval = 9999999,
    children,
    showThumbs = false,
    marginRight,
    minWidth,
    marginControlDots,
    setBottom,
    carouselPosition = 0,
    normalizeInvalidPosition = false,
    ...restProps
}) => {
    const selectedItem = normalizeInvalidPosition
        ? (() => {
              const normalizedCarouselPosition = Number.isInteger(carouselPosition)
                  ? carouselPosition
                  : Number.isInteger(Number(carouselPosition))
                  ? Number(carouselPosition)
                  : 0;
              return normalizedCarouselPosition >= 0
                  ? normalizedCarouselPosition
                  : 0;
          })()
        : carouselPosition;

    return (
        <div>
            <StyledCarousel
                data-testid="custom-carousel"
                autoPlay={autoPlay}
                showThumbs={showThumbs}
                interval={interval}
                marginRight={marginRight}
                minWidth={minWidth}
                marginControlDots={marginControlDots}
                setBottom={setBottom}
                selectedItem={selectedItem}
                {...restProps}
            >
                {children}
            </StyledCarousel>
        </div>
    );
};

export default Carousel;
